import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonos } from '../data/content';
export function Bonos() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-46" data-mp="2ldn0r4h3j5ah">
      <div className="mx-auto w-full max-w-2xl" data-id="element-47" data-mp="2lcbxd5rkbzjw">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-48" data-mp="2q5wyh6ogd9nb">
          Incluido sin costo
        </p>
        <h2 className="mt-3 text-center font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-49" data-mp="2v62ka681k1xh">
          Además recibirás estos 5 bonos exclusivos{' '}
          <span className="text-gold" data-id="element-50" data-mp="353gwftmxm4jz">completamente gratis</span>
        </h2>

        <div className="mt-8 space-y-4" data-id="element-51" data-mp="3940x376prqav">
          {bonos.map(b => <motion.article key={b.n} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.4
        }} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-52" data-mp="1aoecsckkdgoz">
              {b.image && <div className="bg-navy/[0.04] px-4 pt-4" data-id="element-53" data-mp="39b7xfrvdmakh">
                  <img src={b.image} alt={`Portada del bono ${b.title}`} className="mx-auto w-full max-w-xs" data-id="element-54" data-mp="34ezk8k0qorfy" />
                </div>}
              <div className="p-5" data-id="element-55" data-mp="wpqjth6912g">
                <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-56" data-mp="3s420pojn0e8v">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-57" data-mp="3n3wdqlobbfx4" /> Bono #{b.n}
                </p>
                <h3 className="mt-1.5 font-display text-lg font-bold leading-tight text-navy sm:text-xl" data-id="element-58" data-mp="3i6e6czpy18r8">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm font-semibold text-navy/80 sm:text-base" data-id="element-59" data-mp="2bn65kx0bwe0v">{b.lead}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-navy/65 sm:text-base" data-id="element-60" data-mp="26ssh7ek3375p">{b.text}</p>
                <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-gold-pale px-3 py-1 text-xs font-semibold text-navy" data-id="element-61" data-mp="yp5x5mryq8ku">
                  Valor referencial:{' '}
                  <span className="line-through decoration-red-400/80" data-id="element-62" data-mp="oskrcz84ctfy">{b.value}</span>
                  <span className="font-bold text-emerald-700" data-id="element-63" data-mp="tqchbnp7e5hi">HOY GRATIS</span>
                </p>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-9" data-id="element-64" data-mp="jtzo0qxkltna">
          <CTAButton label="Quiero los tomos + los 5 bonos" note="Los bonos se entregan junto con tu acceso" data-id="element-65" data-mp="jvarsqr0n1ee" />
        </div>
      </div>
    </section>;
}